import React from 'react'
import UserFormContainer from './UserFormContainer'
import { EMAIL_ICON } from '../../utils/fontAwesomeDefaults'
import SEO from '../seo/SEO'

const ContactForm = () => {
  return (
    <>
      <SEO
        title='Fit Kit Studio | Contact'
        description='Fit Kit Studio Bike Fitting Software Contact Page'
        type='website'
        name='Fit Kit Systems'
      />
      <UserFormContainer heading='Contact Us' icon={EMAIL_ICON}>
        <p>For help with Fit Kit Studio, please email our support team:</p>
        <p className='text-center'>
          <a href='mailto:studio@fitkitsystems.com'>studio@fitkitsystems.com</a>
        </p>
        <p>You can also call or text:</p>
        <p className='text-center'>(USA) 1-800-434-8548</p>
      </UserFormContainer>
    </>
  )
}

export default ContactForm
